<template>
    <div class="animated fadeIn container-fluid">

        <!-- <b-alert show variant="success">
      <h4 class="alert-heading">{{ $t('menu.system_information') }}</h4>
      <p>試營運~~</p>
      <hr> -->
        <!-- <p>105-02-23 本網站於今(23)日19:00 暫停服務1小時，造成不便敬請見諒～</p> -->
        <!-- 逆境預警偵測 -->
        <!-- <h4 class="card-subtitle mb-2">{{ $t('menu.official_warning') }}</h4>
      <div v-if="alerts.global_alert.length > 0">
        <StressAlert v-for="(alert, idx_ga) in alerts.global_alert" :key="idx_ga"
                     :alert="alert" :showType="'icon_text'"
                     :modalID="'home-top-' + idx_ga + '-' + alert.status_code"></StressAlert>

      </div>
      <div v-else>no Alerts</div> -->

        <!-- 測試所有的 alert -->
        <!-- <StressAlert v-for="(alert, idx_ca_test) in alerts.croppperiod_alert" :key="idx_ca_test"
                     :alert="alert" :showType="'icon_text'"
                     :modalID="'home-test-' + idx_ca_test + '-' + alert.status_code"></StressAlert> -->
        <!-- </b-alert> -->

        <!-- Active Projects -->

        <!-- <b-alert variant="danger" show>
            <h3>
                「阿龜簡單記」上線囉！
                <b-badge variant="danger" class="faa-pulse animated" style="font-size:0.8rem;">NEW</b-badge>
            </h3>
            <p>
                為了幫助您掌握種植期間的每月環境數據，讓您不僅即時監測數據，還能每月檢視數據變化、判斷作物狀況，阿龜推出了月報功能，將環境數據以及縮時攝影照片整理為每月的「生產誌摘要報告」。
                只要在左側管理工具列點選您的專案，便可在列表中看見「生產誌摘要報告」囉，快去試試看吧！
            </p>
            <b-alert variant="success" show>
                <i class="fa fa-info-circle"></i> 進入步驟：左側管理工具列 > 專案列表 > 選擇您的專案 > 阿龜簡單記
            </b-alert>
        </b-alert> -->



        <!-- 一般使用者看到的專案列表 -->
        <div v-if="user_admin == false">

             <b-button variant="success" class="block-text" @click="collapse_links = !collapse_links">
                {{ $t('menu.agri_tools') }}
                <i :class="$tools.style.classToggle(collapse_links)"></i>
            </b-button>

            <b-collapse id="collapse_links" v-model="collapse_links">
                <b-card class="block-area">

                    <b-button class="btn-cp" :href="urls.device_helper" target="_blank">
                        <i class="fa fa-wrench"></i>
                        {{ $t('menu.device_helper') }}
                        <!-- <i class="fa fa-external-link ml-2"></i> -->
                    </b-button>

                    <b-button class="btn-cp" :href="urls.agri_diary" target="_blank">
                        <i class="fa fa-book"></i>
                        <!-- <i class="fa fa-plus"></i> -->
                        {{ $t('menu.agridiary') }} {{ $t('menu.keep_a_diary') }}
                        <!-- <i class="fa fa-external-link ml-2"></i> -->
                    </b-button>

                </b-card>
            </b-collapse>

            <UserProjects></UserProjects>
        </div>



        <div v-else-if="user_admin == true">

            <!-- Admin 快速連結 -->
            <b-button variant="light" class="block-text" @click="collapse_links = !collapse_links">
                <b-badge variant="danger" class="btn-red block-text">Admin</b-badge> Links
                <i :class="$tools.style.classToggle(collapse_links)"></i>
            </b-button>

            <b-collapse id="collapse_links" v-model="collapse_links">
                <b-card class="block-area">
                    <router-link class="btn btn-secondary block-sm" :to="{ name: 'Admin Home' }">Admin Home</router-link>
                    <router-link class="btn btn-secondary block-sm" :to="{ name: 'Search Cropperiods' }">Search Cropperiods</router-link>
                    <router-link class="btn btn-secondary block-sm" :to="{ name: 'List Gateways' }">Gateways</router-link>
                    <router-link class="btn btn-secondary block-sm" :to="{ name: 'List Devices' }">Devices</router-link>
                    <router-link class="btn btn-secondary block-sm" :to="{ name: 'List Users' }">Users</router-link>
                    <router-link class="btn btn-secondary block-sm" :to="{ name: 'Log Users' }">Recent Logs</router-link>
                    <span class="btn btn-secondary block-sm" @click="$config.goTo_Iguanshi('home')">
                        I Guan Shi
                        <!-- <img class="btn-indeedee" :src="$config.getAssetsURL('img/brand/sidebar_icon.png')" alt="go to IGuanShi Home" /> -->
                    </span>

                    <div class="block-text">
                        <b-button variant="dark" class="block-sm text-info" @click="$store.commit('user/set_Theme', 'dark')">
                            <i class="fa fa-moon-o"></i> Dark Theme
                        </b-button>

                        <b-button variant="light" class="block-sm text-primary" @click="$store.commit('user/set_Theme', 'light')">
                            <i class="fa fa-sun-o"></i> Light Theme
                        </b-button>

                        <b-button variant="danger" class="block-sm agri-red" @click="$store.commit('user/set_NotAdmin'); $toastr.s('已假裝你現在不是 admin ~')">
                            <i class="fa fa-adjust"></i> 微服出巡
                        </b-button>
                    </div>

                    <div class="block-text">

                        <b-button class="btn-cp" :href="urls.device_helper" target="_blank">
                            <i class="fa fa-wrench"></i>
                            {{ $t('menu.device_helper') }}
                            <!-- <i class="fa fa-external-link ml-2"></i> -->
                        </b-button>

                    </div>
                </b-card>
            </b-collapse>


            <!-- Admin 專案搜尋 -->
            <b-button variant="warning" class="block-text" @click="collapse_search = !collapse_search">
                <b-badge variant="danger" class="btn-red block-text">Admin</b-badge> Search
                <i :class="$tools.style.classToggle(collapse_search)"></i>
            </b-button>

            <b-collapse id="collapse_search" v-model="collapse_search">
                <b-card class="block-area">

                    <p class="instruction text-center">
                        <i class="fa fa-info-circle"></i> 進入此頁預設會搜尋所有進行中專案，依最近修改時間排序，每頁顯示 10 個專案。
                    </p>

                    <b-row align-h="center">
                        <b-col sm=10 md=8>
                            <SearchProjects :search_on_show="true"></SearchProjects>
                        </b-col>
                    </b-row>

                </b-card>
            </b-collapse>


            <!-- Admin 專案列表 -->
            <AdminProjects></AdminProjects>
        </div>


    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import SearchProjects from '@/views/admin/components/Search_Projects'
    import UserProjects from './components/User_Projects'
    import AdminProjects from './components/Admin_Projects'


    export default {
        components: {
            SearchProjects,
            UserProjects,
            AdminProjects,
        },
        data: function () {
            return {
                collapse_links: true,
                collapse_search: true,
            }
        },
        mounted()
        {
            if ( this.screenWidth < 700 )
            {
                this.collapse_links = false
            }
        },
        computed: {
            ...mapState({
                'user_admin': state => state.user.is_admin,
                'screenWidth': state => state.system.screenWidth,
            }),

            urls ()
            {
                let _hostname = location.hostname
                let _default_url = 'https://cloud.agriweather.online'

                if ( _hostname == 'localhost' ) _default_url = 'https://xlab.agriweather.online'
                else                            _default_url = location.origin

                // agri device helper
                let _agri_diary_url = '/agridiary'
                let _device_helper_url = '/device-helper'

                return {
                    agri_diary:     _default_url + _agri_diary_url,
                    device_helper:  _default_url + _device_helper_url,
                }
            },

        },
        watch: {
            screenWidth (val)
            {
                if ( val < 700 )
                {
                    this.collapse_links = false
                }
            },
        },
        methods: {

        },
    }

</script>

<style lang="scss" scoped>

    .stress-group {
        padding: 0px;
        padding-right: 3px;
    }

    .cp-buttons {
        display: inline-block;
        padding: 3px 0px;
        margin-right: 5px;
        //border-bottom: 1px solid #dddddd;
    }

</style>
